module.exports = __webpack_public_path__ + "media/hph-26-02_school-of-medicine.319bfcca.webm";